export default __webpack_public_path__ + "static/media/About-Tower-viajes-3@2x.43e6ba50.jpg";